/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * ProVersion Platform API
 * RECORTE GERADO — nao editar. Produzido por front/scripts/normative-contract.mjs
 * a partir de contract/openapi.yaml, contendo apenas operacoes `x-maturity: normative`.
 *
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BadRequestResponse,
  ConflictResponse,
  CreateEnrollmentRequest,
  CreatePlanRequest,
  CreateStudentRequest,
  CreateTeacherRequest,
  Enrollment,
  EnrollmentPage,
  ForbiddenResponse,
  ListEnrollmentsParams,
  ListStudentsParams,
  ListTeachersParams,
  NotFoundResponse,
  Plan,
  StudentAdminDetail,
  StudentAdminDetailPage,
  TeacherAdminDetail,
  TeacherAdminDetailPage,
  TerminateEnrollmentRequest,
  UnauthorizedResponse,
  UnprocessableEntityResponse,
  UpdateStudentRequest
} from '../model';

import { apiFetch } from '../../client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getListStudentsUrl = (params?: ListStudentsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/students?${stringifiedParams}` : `/v1/students`
}

/**
 * Operacao exclusiva de Super Admin. Devolve `StudentAdminDetail`, que
 * carrega dado pessoal e por isso nao tem caminho de acesso para professor.
 * Nao existe equivalente para o professor: ele nunca escolhe aluno numa
 * lista.
 * @summary Lista alunos com dado cadastral completo
 */
export const listStudents = async (params?: ListStudentsParams, options?: Parameters<typeof apiFetch>[1]): Promise<StudentAdminDetailPage> => {

  return apiFetch<StudentAdminDetailPage>(getListStudentsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListStudentsQueryKey = (params?: ListStudentsParams,) => {
    return [
    `/v1/students`, ...(params ? [params] : [])
    ] as const;
    }


export const getListStudentsQueryOptions = <TData = Awaited<ReturnType<typeof listStudents>>, TError = UnauthorizedResponse | ForbiddenResponse>(params?: ListStudentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStudents>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListStudentsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listStudents>>> = ({ signal }) => listStudents(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listStudents>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListStudentsQueryResult = NonNullable<Awaited<ReturnType<typeof listStudents>>>
export type ListStudentsQueryError = UnauthorizedResponse | ForbiddenResponse


export function useListStudents<TData = Awaited<ReturnType<typeof listStudents>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params: undefined |  ListStudentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStudents>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listStudents>>,
          TError,
          Awaited<ReturnType<typeof listStudents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListStudents<TData = Awaited<ReturnType<typeof listStudents>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params?: ListStudentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStudents>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listStudents>>,
          TError,
          Awaited<ReturnType<typeof listStudents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListStudents<TData = Awaited<ReturnType<typeof listStudents>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params?: ListStudentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStudents>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista alunos com dado cadastral completo
 */

export function useListStudents<TData = Awaited<ReturnType<typeof listStudents>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params?: ListStudentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listStudents>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListStudentsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCreateStudentUrl = () => {




  return `/v1/students`
}

/**
 * Exclusiva de Super Admin. O nome civil entra por `CivilNameInput`, que e
 * write-only: a resposta ja e projetada e devolve somente `displayName`.
 * @summary Cadastra um aluno
 */
export const createStudent = async (createStudentRequest: CreateStudentRequest, options?: Parameters<typeof apiFetch>[1]): Promise<StudentAdminDetail> => {

  return apiFetch<StudentAdminDetail>(getCreateStudentUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createStudentRequest)
  }
);}





export const getCreateStudentMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | ConflictResponse | UnprocessableEntityResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createStudent>>, TError,{data: CreateStudentRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createStudent>>, TError,{data: CreateStudentRequest}, TContext> => {

const mutationKey = ['createStudent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createStudent>>, {data: CreateStudentRequest}> = (props) => {
          const {data} = props ?? {};

          return  createStudent(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateStudentMutationResult = NonNullable<Awaited<ReturnType<typeof createStudent>>>
    export type CreateStudentMutationBody = CreateStudentRequest
    export type CreateStudentMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | ConflictResponse | UnprocessableEntityResponse

    /**
 * @summary Cadastra um aluno
 */
export const useCreateStudent = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | ConflictResponse | UnprocessableEntityResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createStudent>>, TError,{data: CreateStudentRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createStudent>>,
        TError,
        {data: CreateStudentRequest},
        TContext
      > => {
      return useMutation(getCreateStudentMutationOptions(options), queryClient);
    }
    export const getGetStudentUrl = (studentId: string,) => {




  return `/v1/students/${studentId}`
}

/**
 * Exclusiva de Super Admin, pela mesma razao de `listStudents`.
 * @summary Detalha um aluno
 */
export const getStudent = async (studentId: string, options?: Parameters<typeof apiFetch>[1]): Promise<StudentAdminDetail> => {

  return apiFetch<StudentAdminDetail>(getGetStudentUrl(studentId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetStudentQueryKey = (studentId: string,) => {
    return [
    `/v1/students/${studentId}`
    ] as const;
    }


export const getGetStudentQueryOptions = <TData = Awaited<ReturnType<typeof getStudent>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(studentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStudent>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStudentQueryKey(studentId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStudent>>> = ({ signal }) => getStudent(studentId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: studentId !== null && studentId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStudent>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStudentQueryResult = NonNullable<Awaited<ReturnType<typeof getStudent>>>
export type GetStudentQueryError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse


export function useGetStudent<TData = Awaited<ReturnType<typeof getStudent>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
 studentId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStudent>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStudent>>,
          TError,
          Awaited<ReturnType<typeof getStudent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStudent<TData = Awaited<ReturnType<typeof getStudent>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
 studentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStudent>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStudent>>,
          TError,
          Awaited<ReturnType<typeof getStudent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStudent<TData = Awaited<ReturnType<typeof getStudent>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
 studentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStudent>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Detalha um aluno
 */

export function useGetStudent<TData = Awaited<ReturnType<typeof getStudent>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
 studentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStudent>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetStudentQueryOptions(studentId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getUpdateStudentUrl = (studentId: string,) => {




  return `/v1/students/${studentId}`
}

/**
 * Exclusiva de Super Admin.
 * @summary Altera o cadastro de um aluno
 */
export const updateStudent = async (studentId: string,
    updateStudentRequest: UpdateStudentRequest, options?: Parameters<typeof apiFetch>[1]): Promise<StudentAdminDetail> => {

  return apiFetch<StudentAdminDetail>(getUpdateStudentUrl(studentId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateStudentRequest)
  }
);}





export const getUpdateStudentMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateStudent>>, TError,{studentId: string;data: UpdateStudentRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateStudent>>, TError,{studentId: string;data: UpdateStudentRequest}, TContext> => {

const mutationKey = ['updateStudent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateStudent>>, {studentId: string;data: UpdateStudentRequest}> = (props) => {
          const {studentId,data} = props ?? {};

          return  updateStudent(studentId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateStudentMutationResult = NonNullable<Awaited<ReturnType<typeof updateStudent>>>
    export type UpdateStudentMutationBody = UpdateStudentRequest
    export type UpdateStudentMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse

    /**
 * @summary Altera o cadastro de um aluno
 */
export const useUpdateStudent = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateStudent>>, TError,{studentId: string;data: UpdateStudentRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateStudent>>,
        TError,
        {studentId: string;data: UpdateStudentRequest},
        TContext
      > => {
      return useMutation(getUpdateStudentMutationOptions(options), queryClient);
    }
    export const getListTeachersUrl = (params?: ListTeachersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/teachers?${stringifiedParams}` : `/v1/teachers`
}

/**
 * Exclusiva de Super Admin.
 * @summary Lista professores
 */
export const listTeachers = async (params?: ListTeachersParams, options?: Parameters<typeof apiFetch>[1]): Promise<TeacherAdminDetailPage> => {

  return apiFetch<TeacherAdminDetailPage>(getListTeachersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTeachersQueryKey = (params?: ListTeachersParams,) => {
    return [
    `/v1/teachers`, ...(params ? [params] : [])
    ] as const;
    }


export const getListTeachersQueryOptions = <TData = Awaited<ReturnType<typeof listTeachers>>, TError = UnauthorizedResponse | ForbiddenResponse>(params?: ListTeachersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTeachers>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTeachersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTeachers>>> = ({ signal }) => listTeachers(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTeachers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTeachersQueryResult = NonNullable<Awaited<ReturnType<typeof listTeachers>>>
export type ListTeachersQueryError = UnauthorizedResponse | ForbiddenResponse


export function useListTeachers<TData = Awaited<ReturnType<typeof listTeachers>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params: undefined |  ListTeachersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTeachers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTeachers>>,
          TError,
          Awaited<ReturnType<typeof listTeachers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTeachers<TData = Awaited<ReturnType<typeof listTeachers>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params?: ListTeachersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTeachers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTeachers>>,
          TError,
          Awaited<ReturnType<typeof listTeachers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTeachers<TData = Awaited<ReturnType<typeof listTeachers>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params?: ListTeachersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTeachers>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista professores
 */

export function useListTeachers<TData = Awaited<ReturnType<typeof listTeachers>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params?: ListTeachersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTeachers>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTeachersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCreateTeacherUrl = () => {




  return `/v1/teachers`
}

/**
 * Exclusiva de Super Admin. O nome civil entra por `CivilNameInput`, que e
 * write-only: a resposta ja e projetada e devolve somente `displayName`.
 *
 * O valor por aula nao entra aqui: ele e da
 * Onda 4 e tem historico proprio, em `putTeacherRate`.
 * @summary Cadastra um professor
 */
export const createTeacher = async (createTeacherRequest: CreateTeacherRequest, options?: Parameters<typeof apiFetch>[1]): Promise<TeacherAdminDetail> => {

  return apiFetch<TeacherAdminDetail>(getCreateTeacherUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createTeacherRequest)
  }
);}





export const getCreateTeacherMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | ConflictResponse | UnprocessableEntityResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTeacher>>, TError,{data: CreateTeacherRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTeacher>>, TError,{data: CreateTeacherRequest}, TContext> => {

const mutationKey = ['createTeacher'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTeacher>>, {data: CreateTeacherRequest}> = (props) => {
          const {data} = props ?? {};

          return  createTeacher(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTeacherMutationResult = NonNullable<Awaited<ReturnType<typeof createTeacher>>>
    export type CreateTeacherMutationBody = CreateTeacherRequest
    export type CreateTeacherMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | ConflictResponse | UnprocessableEntityResponse

    /**
 * @summary Cadastra um professor
 */
export const useCreateTeacher = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | ConflictResponse | UnprocessableEntityResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTeacher>>, TError,{data: CreateTeacherRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createTeacher>>,
        TError,
        {data: CreateTeacherRequest},
        TContext
      > => {
      return useMutation(getCreateTeacherMutationOptions(options), queryClient);
    }
    export const getGetTeacherUrl = (teacherId: string,) => {




  return `/v1/teachers/${teacherId}`
}

/**
 * Exclusiva de Super Admin.
 * @summary Detalha um professor
 */
export const getTeacher = async (teacherId: string, options?: Parameters<typeof apiFetch>[1]): Promise<TeacherAdminDetail> => {

  return apiFetch<TeacherAdminDetail>(getGetTeacherUrl(teacherId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTeacherQueryKey = (teacherId: string,) => {
    return [
    `/v1/teachers/${teacherId}`
    ] as const;
    }


export const getGetTeacherQueryOptions = <TData = Awaited<ReturnType<typeof getTeacher>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(teacherId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeacher>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTeacherQueryKey(teacherId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeacher>>> = ({ signal }) => getTeacher(teacherId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teacherId !== null && teacherId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTeacher>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTeacherQueryResult = NonNullable<Awaited<ReturnType<typeof getTeacher>>>
export type GetTeacherQueryError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse


export function useGetTeacher<TData = Awaited<ReturnType<typeof getTeacher>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
 teacherId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeacher>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeacher>>,
          TError,
          Awaited<ReturnType<typeof getTeacher>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeacher<TData = Awaited<ReturnType<typeof getTeacher>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
 teacherId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeacher>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeacher>>,
          TError,
          Awaited<ReturnType<typeof getTeacher>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeacher<TData = Awaited<ReturnType<typeof getTeacher>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
 teacherId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeacher>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Detalha um professor
 */

export function useGetTeacher<TData = Awaited<ReturnType<typeof getTeacher>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
 teacherId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeacher>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTeacherQueryOptions(teacherId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListPlansUrl = () => {




  return `/v1/plans`
}

/**
 * O plano descreve a cadencia — aulas por semana, duracao — e nao o preco.
 * Preco e `ledger`, Onda 3, e esta bloqueado pela §15.2.
 * @summary Lista planos de aula
 */
export const listPlans = async ( options?: Parameters<typeof apiFetch>[1]): Promise<Plan[]> => {

  return apiFetch<Plan[]>(getListPlansUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPlansQueryKey = () => {
    return [
    `/v1/plans`
    ] as const;
    }


export const getListPlansQueryOptions = <TData = Awaited<ReturnType<typeof listPlans>>, TError = UnauthorizedResponse | ForbiddenResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlans>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPlansQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPlans>>> = ({ signal }) => listPlans({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPlans>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPlansQueryResult = NonNullable<Awaited<ReturnType<typeof listPlans>>>
export type ListPlansQueryError = UnauthorizedResponse | ForbiddenResponse


export function useListPlans<TData = Awaited<ReturnType<typeof listPlans>>, TError = UnauthorizedResponse | ForbiddenResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlans>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPlans>>,
          TError,
          Awaited<ReturnType<typeof listPlans>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPlans<TData = Awaited<ReturnType<typeof listPlans>>, TError = UnauthorizedResponse | ForbiddenResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlans>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPlans>>,
          TError,
          Awaited<ReturnType<typeof listPlans>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPlans<TData = Awaited<ReturnType<typeof listPlans>>, TError = UnauthorizedResponse | ForbiddenResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlans>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista planos de aula
 */

export function useListPlans<TData = Awaited<ReturnType<typeof listPlans>>, TError = UnauthorizedResponse | ForbiddenResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlans>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPlansQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCreatePlanUrl = () => {




  return `/v1/plans`
}

/**
 * Exclusiva de Super Admin.
 * @summary Cria um plano de aula
 */
export const createPlan = async (createPlanRequest: CreatePlanRequest, options?: Parameters<typeof apiFetch>[1]): Promise<Plan> => {

  return apiFetch<Plan>(getCreatePlanUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createPlanRequest)
  }
);}





export const getCreatePlanMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | UnprocessableEntityResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPlan>>, TError,{data: CreatePlanRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPlan>>, TError,{data: CreatePlanRequest}, TContext> => {

const mutationKey = ['createPlan'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPlan>>, {data: CreatePlanRequest}> = (props) => {
          const {data} = props ?? {};

          return  createPlan(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePlanMutationResult = NonNullable<Awaited<ReturnType<typeof createPlan>>>
    export type CreatePlanMutationBody = CreatePlanRequest
    export type CreatePlanMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | UnprocessableEntityResponse

    /**
 * @summary Cria um plano de aula
 */
export const useCreatePlan = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | UnprocessableEntityResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPlan>>, TError,{data: CreatePlanRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createPlan>>,
        TError,
        {data: CreatePlanRequest},
        TContext
      > => {
      return useMutation(getCreatePlanMutationOptions(options), queryClient);
    }
    export const getListEnrollmentsUrl = (params?: ListEnrollmentsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/enrollments?${stringifiedParams}` : `/v1/enrollments`
}

/**
 * Exclusiva de Super Admin. A matricula liga aluno, plano e professor, e e
 * ela que constitui o vinculo ativo do qual dependem a sala, o acadamico e
 * a caixa de mensagens.
 * @summary Lista matriculas
 */
export const listEnrollments = async (params?: ListEnrollmentsParams, options?: Parameters<typeof apiFetch>[1]): Promise<EnrollmentPage> => {

  return apiFetch<EnrollmentPage>(getListEnrollmentsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListEnrollmentsQueryKey = (params?: ListEnrollmentsParams,) => {
    return [
    `/v1/enrollments`, ...(params ? [params] : [])
    ] as const;
    }


export const getListEnrollmentsQueryOptions = <TData = Awaited<ReturnType<typeof listEnrollments>>, TError = UnauthorizedResponse | ForbiddenResponse>(params?: ListEnrollmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEnrollments>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListEnrollmentsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listEnrollments>>> = ({ signal }) => listEnrollments(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listEnrollments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListEnrollmentsQueryResult = NonNullable<Awaited<ReturnType<typeof listEnrollments>>>
export type ListEnrollmentsQueryError = UnauthorizedResponse | ForbiddenResponse


export function useListEnrollments<TData = Awaited<ReturnType<typeof listEnrollments>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params: undefined |  ListEnrollmentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEnrollments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEnrollments>>,
          TError,
          Awaited<ReturnType<typeof listEnrollments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListEnrollments<TData = Awaited<ReturnType<typeof listEnrollments>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params?: ListEnrollmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEnrollments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEnrollments>>,
          TError,
          Awaited<ReturnType<typeof listEnrollments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListEnrollments<TData = Awaited<ReturnType<typeof listEnrollments>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params?: ListEnrollmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEnrollments>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista matriculas
 */

export function useListEnrollments<TData = Awaited<ReturnType<typeof listEnrollments>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params?: ListEnrollmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEnrollments>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListEnrollmentsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCreateEnrollmentUrl = () => {




  return `/v1/enrollments`
}

/**
 * Exclusiva de Super Admin. E esta operacao que constitui o vinculo ativo
 * do qual dependem a sala, o academico, a caixa de mensagens, a cobranca e
 * a folha.
 * @summary Matricula um aluno em um plano com um professor
 */
export const createEnrollment = async (createEnrollmentRequest: CreateEnrollmentRequest, options?: Parameters<typeof apiFetch>[1]): Promise<Enrollment> => {

  return apiFetch<Enrollment>(getCreateEnrollmentUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createEnrollmentRequest)
  }
);}





export const getCreateEnrollmentMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | ConflictResponse | UnprocessableEntityResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEnrollment>>, TError,{data: CreateEnrollmentRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createEnrollment>>, TError,{data: CreateEnrollmentRequest}, TContext> => {

const mutationKey = ['createEnrollment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createEnrollment>>, {data: CreateEnrollmentRequest}> = (props) => {
          const {data} = props ?? {};

          return  createEnrollment(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateEnrollmentMutationResult = NonNullable<Awaited<ReturnType<typeof createEnrollment>>>
    export type CreateEnrollmentMutationBody = CreateEnrollmentRequest
    export type CreateEnrollmentMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | ConflictResponse | UnprocessableEntityResponse

    /**
 * @summary Matricula um aluno em um plano com um professor
 */
export const useCreateEnrollment = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | ConflictResponse | UnprocessableEntityResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEnrollment>>, TError,{data: CreateEnrollmentRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createEnrollment>>,
        TError,
        {data: CreateEnrollmentRequest},
        TContext
      > => {
      return useMutation(getCreateEnrollmentMutationOptions(options), queryClient);
    }
    export const getTerminateEnrollmentUrl = (enrollmentId: string,) => {




  return `/v1/enrollments/${enrollmentId}/termination`
}

/**
 * Exclusiva de Super Admin e sensivel: exige reautenticacao recente.
 * Encerrar a matricula fecha a caixa de mensagens para envio e preserva o
 * historico, conforme a decisao registrada no roadmap.
 * @summary Encerra uma matricula
 */
export const terminateEnrollment = async (enrollmentId: string,
    terminateEnrollmentRequest: TerminateEnrollmentRequest, options?: Parameters<typeof apiFetch>[1]): Promise<Enrollment> => {

  return apiFetch<Enrollment>(getTerminateEnrollmentUrl(enrollmentId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(terminateEnrollmentRequest)
  }
);}





export const getTerminateEnrollmentMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof terminateEnrollment>>, TError,{enrollmentId: string;data: TerminateEnrollmentRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof terminateEnrollment>>, TError,{enrollmentId: string;data: TerminateEnrollmentRequest}, TContext> => {

const mutationKey = ['terminateEnrollment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof terminateEnrollment>>, {enrollmentId: string;data: TerminateEnrollmentRequest}> = (props) => {
          const {enrollmentId,data} = props ?? {};

          return  terminateEnrollment(enrollmentId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TerminateEnrollmentMutationResult = NonNullable<Awaited<ReturnType<typeof terminateEnrollment>>>
    export type TerminateEnrollmentMutationBody = TerminateEnrollmentRequest
    export type TerminateEnrollmentMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse

    /**
 * @summary Encerra uma matricula
 */
export const useTerminateEnrollment = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof terminateEnrollment>>, TError,{enrollmentId: string;data: TerminateEnrollmentRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof terminateEnrollment>>,
        TError,
        {enrollmentId: string;data: TerminateEnrollmentRequest},
        TContext
      > => {
      return useMutation(getTerminateEnrollmentMutationOptions(options), queryClient);
    }
    export const getGetMyEnrollmentUrl = () => {




  return `/v1/me/enrollment`
}

/**
 * Do aluno. Devolve o professor como `displayName` mascarado.
 * @summary Descreve a propria matricula
 */
export const getMyEnrollment = async ( options?: Parameters<typeof apiFetch>[1]): Promise<Enrollment> => {

  return apiFetch<Enrollment>(getGetMyEnrollmentUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMyEnrollmentQueryKey = () => {
    return [
    `/v1/me/enrollment`
    ] as const;
    }


export const getGetMyEnrollmentQueryOptions = <TData = Awaited<ReturnType<typeof getMyEnrollment>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyEnrollment>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyEnrollmentQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyEnrollment>>> = ({ signal }) => getMyEnrollment({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyEnrollment>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMyEnrollmentQueryResult = NonNullable<Awaited<ReturnType<typeof getMyEnrollment>>>
export type GetMyEnrollmentQueryError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse


export function useGetMyEnrollment<TData = Awaited<ReturnType<typeof getMyEnrollment>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyEnrollment>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyEnrollment>>,
          TError,
          Awaited<ReturnType<typeof getMyEnrollment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyEnrollment<TData = Awaited<ReturnType<typeof getMyEnrollment>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyEnrollment>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyEnrollment>>,
          TError,
          Awaited<ReturnType<typeof getMyEnrollment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyEnrollment<TData = Awaited<ReturnType<typeof getMyEnrollment>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyEnrollment>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Descreve a propria matricula
 */

export function useGetMyEnrollment<TData = Awaited<ReturnType<typeof getMyEnrollment>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyEnrollment>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMyEnrollmentQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






